import reducers from './reducers'

export { default as valuesTypes } from './types'
export { default as valuesActions } from './actions'
export { default as valuesSelectors } from './selectors'
export { default as valuesEpics } from './epics'

export default reducers
